import { TransferDraft, TransferDraftErrors } from "../entities";
import { featureFlags } from "./featureFlags";

/**
 * Checks transfer draft form for any missed out `TransferDraftError` &
 * returns a set of errors.
 *
 * @param transferDraft
 * @returns a set of TransferDraftError.
 */
export const validateFormAndReturnErrorIfAny = (
  transferDraft: TransferDraft
): Set<TransferDraftErrors> => {
  const transferDraftErrors: Set<TransferDraftErrors> =
    new Set<TransferDraftErrors>();

  const isSenderNameInvalid: boolean = !transferDraft.anon.name;

  const isSenderEmailBlank: boolean = !transferDraft.anon.email;

  const senderEmailMatch = transferDraft.anon.email.match(
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  );

  const isSenderEmailInvalid: boolean = !senderEmailMatch || isSenderEmailBlank;

  // Sender's name validation
  if (isSenderNameInvalid) {
    transferDraftErrors.add(TransferDraftErrors.blankSenderName);
  }

  // Sender's email validation
  if (isSenderEmailInvalid) {
    transferDraftErrors.add(TransferDraftErrors.invalidSenderEmail);
  }

  // TODO: Remove this block when lifting the flag `REACT_APP_FF_NO_FILES_TRANSFER`
  if (!featureFlags.noFilesTransfer) {
    if (!transferDraft.files.length) {
      transferDraftErrors.add(TransferDraftErrors.invalidFileCount);
    }
  }

  return transferDraftErrors;
};
